// DBMS manifest 로딩 액션. 앱 시작 시 1회 호출.

import axios from 'axios';
import { DBMS_MANIFESTS_SET, DBMS_MANIFESTS_ERROR } from '../reducers/dbmsReducer';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || '/sql-developer').replace(/\/+$/, '');

export const loadDbmsManifests = () => async (dispatch) => {
    try {
        const res = await axios.get(`${API_BASE}/dbtypes`, { timeout: 8000 });
        const list = Array.isArray(res.data) ? res.data : [];
        dispatch({ type: DBMS_MANIFESTS_SET, payload: list });
        return list;
    } catch (err) {
        console.warn('[dbmsActions] loadDbmsManifests 실패:', err.message);
        dispatch({ type: DBMS_MANIFESTS_ERROR, payload: err.message });
        return [];
    }
};
